import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import renderHTML from 'react-render-html';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import '../Iniciativas.scss';
import './ProgramaDeCompliance.scss';

class ProgramaDeCompliance extends Component {
  constructor(props) {
		super(props);

		this.state = {
			selected: 'mulher',
			mobile: (window.innerWidth < 768) ? true : false
		}

		this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();

		// if (this.state.mobile == true) {
		// 	this.mobileNav();
		// }
	}
	
	mobileNav = () => {
	}

	changeItem = () => {
		const { selected } = this.state
		this.setState({
			selected: (selected == 'mulher') ? 'homem' : 'mulher'
		});
	}

  render = () => {
		const { selected } = this.state
    return (
      <div className="views" ref={this.contentText}>
				<Helmet>
					<title>Programa de Compliance - Iniciativas - {texts.title}</title>
				</Helmet>
				
				<div className="iniciativas-home treinamentos-home page-gradient page-gradient--yellow bg-gray bg-programa-de-supervisao" ref="treinamentos-home">
					<section className="iniciativas-area page--yellow">
						<div className="container container--large">
							<div className="row">
								<div className="col-12">
									<Fade bottom>
										<div className={`card card--page-body card--light-blue`}>
											<div className="card__content">
												<div className="card__content__header after-header-programa-de-supervisao">
													<DelayLink to={`/estrategias/dentro-de-casa`} className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
														Voltar
													</DelayLink>
													<h1 className="title title--gray titulo-programa-de-supervisao">
                            Programa de Compliance é reformulado
														<span className="gri-compliance">  
                              GRI <b>103-1, 103-2, 103-3 | 205</b>
														</span>
													</h1>
												</div>
												<div className="conteudo-programa-de-compliance">
                          <div className="conteudo-imagem-programa-de-compliance anima-img">
													  <img src={images.programa_de_compliance.imagem_compliance} alt="Home"/>
                          </div>
													<p>
                            Sempre pautados pela conduta ética, reformulamos nosso Programa de Compliance, revisamos o Código de Ética e Conduta Profissional e reestruturamos as políticas e normas internas em 2020.
                            <br/><br/>
                            O objetivo foi garantir que o relacionamento com associados, reguladores, fornecedores e colegas de trabalho ocorra de maneira ainda mais correta e íntegra.
                            <br /><br />
                            Para disseminar e consolidar essas práticas, adotamos a plataforma Be Compliance, que reúne treinamentos, documentos e políticas relacionadas a temas como contratação de terceiros, combate à corrupção, Lei Geral de Proteção de Dados e outras boas práticas. Conta também com um canal de denúncias administrado por consultoria externa que garante a confidencialidade das informações.
                            <br /><br/>
                            O programa de compliance permite que os riscos inerentes à nossa atividade sejam identificados e tratados, protegendo tanto a Associação quanto os colaboradores e parceiros. Abrangente, engloba aspectos legais, regulatórios e reputacionais relacionados às nossas atividades.
                            <span className="gri-texto-compliance">GRI <b>102-15</b></span>
                            <br/><br/>
                            Sobre as questões relacionadas à cibersegurança, foi dada continuidade em 2020 ao trabalho de aprimoramento de processos de tecnologia e segurança da informação. Depois da revisão da política de segurança da informação, concluída em 2020, todos os funcionários passaram por treinamento.
                          </p>
												</div>
											</div>
										</div>
									</Fade>
								</div>
							</div>
						</div>
					</section>
				</div>
      </div>
    );
  }
}

export { ProgramaDeCompliance };
